import styled from 'styled-components';

export const Wrapper = styled.div`
width: 100%;
box-sizing: border-box;
`;

export const Container = styled.div`
width: 100%;
box-sizing: border-box;
display: flex;
flex-flow: column;
align-items: flex-start;
justify-content: flex-start;
`;

export const BreadCrumbs = styled.div`
width: 100%;
box-sizing: border-box;
padding: 20px 0;
`;

export const FormSection = styled.div`
width: 100%;
box-sizing: border-box;
display: flex;
flex-flow: column;
align-items: flex-start;
justify-content: flex-start;
background-color: #ffffff;
box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.12);
border-radius: 8px;
margin-bottom: 54px;
`;

export const SectionTitle = styled.div`
width: 100%;
box-sizing: border-box;
font-weight: 600;
font-size: 18px;
line-height: 27px;
color: #000000;
padding: 30px;
border-bottom: 1px solid #E9EDF5;
`;

export const SectionBody = styled.div`
padding: 30px;
width: 100%;
box-sizing: border-box;
`;

export const PermitionSectoinTitle = styled.div`
font-weight: 600;
font-size: 18px;
line-height: 22px;
color: #000000;
margin: 0 0 30px 0;
`;

export const AccountDetailTitleSection = styled.div`
width: 100%;
box-sizing: border-box;
display: flex;
flex-flow: row nowrap;
align-items: center;
justify-content: space-between;
`;

export const Title = styled.div`
font-weight: 600;
font-size: 18px;
line-height: 27px;
color: #000000;
margin-bottom:8px;
`;

export const Subtitle = styled.div`
font-weight: 400;
font-size: 14px;
line-height: 21px;
color: #000000;
margin-bottom: 30px;
`;

export const UserProfilename = styled.div`
width: 34px;
height: 34px;
border-radius: 50%;
color: #232D42;;
background-color:#968989;
font-size: 16px;
font-weight: 400;
display: flex;
flex-flow: row wrap;
align-items: center;
justify-content: center;
margin-right: 8px;
`;

export const UserName = styled.div`
font-weight: 400;
font-size: 14px;
color: #232D42;
`;

export const UserDetail = styled.div`
display: flex;
flex-flow: row nowrap;
align-items: center;
justify-content: flex-start;
`;

export const AddStaffFormBody = styled.div`
width: 500px;
padding: 30px 30px 15px 30px;
`;

export const ModalFooter = styled.div`
width: 100%;
box-sizing: border-box;
text-align: right;
padding: 0 30px 30px 0
`;